import Vue from 'vue'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'

if (process.env.NODE_ENV === 'production') {
  Raven
    .config(process.env.VUE_APP_RAVEN)
    .addPlugin(RavenVue, Vue)
    .install()
}
